export enum DomainPurchaseStatus {
    Pending = 'pending',
    Succeeded = 'succeeded',
    Failed = 'failed',
    Cancelled = 'cancelled',
}